module.exports = __webpack_public_path__ + "img/mq.a09e4865.svg";